module.exports = __webpack_public_path__ + "media/notre_mission/drawing-8d59c93b.png";